import React, { useEffect, useState } from "react";
import styles from "../styles/SlidePort.module.css";
import classNames from "classnames";
import { useGetPortfolioMutation } from "../services/PortfolioSerivce/PortfolioService";

export type TypeArrPort = {
  title: string;
  image: string;
  url_website: string;
  description: string;
}[];

type TypeSlideUpDown = {
  data_port: TypeArrPort;
};

type TypePortfolioResponse = {
  _id: string;
  title: string;
  description: string;
  url_website: string;
  image: string;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
};

const SlidePort = () => {
  const [getPortfolio, result_portfolio] = useGetPortfolioMutation();
  const [slide_arr, setSlideArr] = useState<TypeArrPort[]>([]);

  const fnGetPortfolio = async () => {
    try {
      const result = await getPortfolio().unwrap();
      if (result.status === 200) {
        if (result.data) {
          setSlideArr(setArray(result.data));
        }
      }
    } catch (err) {
      return;
    }
  };

  useEffect(() => {
    fnGetPortfolio();
  }, []);

  const image_mock =
    "https://images.unsplash.com/photo-1538291323976-37dcaafccb12?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2564&q=80";
  const setArray = (data_slide: TypePortfolioResponse[]) => {
    const arr_four: any = [[], [], [], []];
    for (let i = 0; i < data_slide.length; i++) {
      const modCol = i % 4;
      arr_four[modCol].push(data_slide[i]);
    }

    for (let i = 0; i < arr_four.length; i++) {
      while (arr_four[i].length < 4) {
        arr_four[i].push({
          img: "",
          link: "#",
        });
      }
    }

    return arr_four;
  };

  const slideUpDown = slide_arr.map(
    (columnData: TypeArrPort, columnIndex: number) => (
      <div key={columnIndex} className="flex flex-col">
        <div className={classNames(styles.colSlide)}>
          <div
            className={classNames(
              columnIndex % 2 === 0 ? styles.slideShowUp : styles.slideShowDown
            )}
          >
            {columnData.map((item, rowIndex: number) => (
              <div key={rowIndex} className={styles.contentBoxDiv}>
                <a href={item.url_website} target="_blank" className="w-full">
                  <img
                    // src={`http://localhost:5500${item.image}`}
                    src={item.image ? item.image : image_mock}
                    alt={item.url_website}
                    className={styles.contentBox}
                  />
                </a>
                {/* <a href={item.link}>{item.link}</a> */}
              </div>
            ))}
          </div>

          <div
            className={classNames(
              columnIndex % 2 === 0 ? styles.slideShowUp : styles.slideShowDown
            )}
          >
            {columnData.map((item, rowIndex: number) => (
              <div key={rowIndex} className={styles.contentBoxDiv}>
                <a href={item.url_website} target="_blank" className="w-full">
                  <img
                    src={item.image ? item.image : image_mock} //image_mock
                    alt={item.url_website}
                    className={styles.contentBox}
                  />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  );

  return (
    <div className="flex justify-center relative">
      {result_portfolio.isLoading ? (
        <>
          <div className="h-[200px] w-full flex flex-col justify-center items-center">
            <div className="h-[60px] w-[60px] rounded-[100px] border-solid border-[7px] border-custom-primary-25  border-b-custom-secondary-50 animate-spin"></div>
          </div>
        </>
      ) : (
        <>
          {result_portfolio.isError ? (
            <>
              <div className="h-[200px] flex flex-col justify-center items-center bg-custom-secondary-50">
                <p className="text-custom-gray-75 tracking-[5px] text-[14px]">
                  No Data
                </p>
              </div>
            </>
          ) : (
            <>
              <div className={styles.contentSlide}>{slideUpDown}</div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SlidePort;
